import { render, staticRenderFns } from "./Infrastructure.vue?vue&type=template&id=45546af4&scoped=true&"
import script from "./Infrastructure.vue?vue&type=script&lang=js&"
export * from "./Infrastructure.vue?vue&type=script&lang=js&"
import style0 from "./Infrastructure.vue?vue&type=style&index=0&id=45546af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45546af4",
  null
  
)

export default component.exports